// Libraries
var React = require('react');

// Styles
require('./TicketAvailability.scss');

// Components
var TicketAvailabilityFixture = require('./TicketAvailabilityFixture');
var ConditionalWrapper = require('../../common/ConditionalWrapper/ConditionalWrapper');

class TicketAvailabilityModule extends React.Component {

	render() {
		return (
			<ConditionalWrapper condition={this.props.data.isOneHotspur} wrapper={children => <section className='c-section c-section--always-padded c-section--one-hotspur c-ticket-availability--one-hotspur'>{children}</section>}>
				<div className="TicketAvailability">
					{this.props.data.fixtures && this.props.data.fixtures.map((fixture, index) => {
							return (<TicketAvailabilityFixture key={index} fixture={fixture} />);
						})
					}
				</div>
			</ConditionalWrapper>
		)
	}
}

module.exports = TicketAvailabilityModule;



// WEBPACK FOOTER //
// ./src/components/Membership/TicketAvailabilityModule.js